import QuickEditOverlay from 'components/admin-bridge/QuickEditOverlay';
import Dropdown from 'components/admin2/ui/Dropdown';
import { THEME_PADDING } from 'style/mixins';
import styled, { css } from 'styled-components';
import { IBlockRegion } from './utils';
import { SURFACE_2 } from 'style/constants';

export const StyledQuickEditOverlay = styled(QuickEditOverlay)<{ region: IBlockRegion; }>`
  ${THEME_PADDING}
  gap: 50px;

  ${({ region }) => region === 'panel' && css`
    padding: 12px;
    padding-top: 30px;
    overflow-x: hidden;
    flex: 1;
    background-color: ${SURFACE_2};
  `};
`;

export const BackgroundImage = styled.img`
  inset: 0px;
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const StyledDropdown = styled(Dropdown)`
  height: 44.48px;
  min-width: 200px;

  & .dropdown-button {
    height: 44.48px;
    min-height: unset;
  }
`;
